import React, { Fragment, useState } from 'react';
import connect from 'react-redux/lib/connect/connect';
import { CancelBetting } from '../../../common/actions/betAction';
import { isEmpty, dateFormation,convertResultType, convertTypeString, convertClass, convertTeamName, getMarketDetail, convertNameKor, getImgPath, fixedNumber, convertBettingHistory, onErrorImg } from '../../../common/cores';
import { perPage, sportPerPage } from '../../../utils';


const Sportshistory = (props) => {
  const [ showHis, setShowHis ] = useState(false);
  
  const CancelBetting = (id) => {
    // //console.log(id, type)
    props.onPopup();
    props.setSaveId(id);
  }
  // console.log(props);
  const showHisotry = () => {
    setShowHis(!showHis);
  }
  let fixture_ids = [];
    const {   page, index, active } = props;
   
    const history = props.history.data;
    const history_status = props.history.status;

    const height = showHis? { height: "45px", transition: "0.3s" } : { height: "0px", transition: "0.3s", overflow: "hidden" }
    return !isEmpty(history.odds) && (
        <Fragment>
          <tr key={index}>
            <td className="col-1" onClick={showHisotry}>{isNaN(page.curPage) ? 0 : (page.curPage - 1) * perPage + index + 1}</td>
            <td data-v-9dbb6d4c onClick={showHisotry} >{isEmpty(history.created_date) ? '': dateFormation(history.created_date)}</td>
            <td data-v-9dbb6d4c onClick={showHisotry}  className="word-wrap">{isEmpty(history.balance) ? '' : fixedNumber(Number(history.rate))}</td>
            <td data-v-9dbb6d4c onClick={showHisotry}  className="word-wrap">{isEmpty(history.balance) ? '' : Number(history.balance.bet).toLocaleString()}</td>
            <td data-v-9dbb6d4c onClick={showHisotry}  className="word-wrap">
            { (isEmpty(history.balance) ? '' : Math.floor((Number(history.last_rate || history.rate) * Number(history.balance.bet))).toLocaleString())}
            </td> 
            <td data-v-9dbb6d4c onClick={showHisotry}  className = {convertClass(history.type)}>{convertTypeString(history.type)}</td>
            <td data-v-9dbb6d4c className="" style={{ width: '40px', minWidth: '40px', maxWidth: '40px', cursor: "pointer" }}>
              {((history.type === 'waiting') && (active != "live") && history_status) && <img src="../images/common/icon_trash.png" className="napam-btn_clear" onClick={() => CancelBetting(history._id)} alt="" />}
            </td>
          </tr>
          <tr>
            <td colSpan="7" className={`${ !showHis && "border-none"}`} style={{ padding: 0, height: showHis ? "" : "0px", overflow: !showHis && "hidden" }}>
              <div style={{ height:showHis ? "" : '0', padding: showHis ? "15px 0" : '0', transition: "0.3s" }}>
                <div data-v-7c26ed95="" data-v-0b388a17="" className="history-log scrollable-auto column col">
                  <div data-v-7c26ed95="" className="title d-flex" style={{ flexDirection: "row", ...height }}>
                    <span data-v-7c26ed95="" className="text" style={{fontSize:"13px", opacity: "0.7" }}>배팅상세내역</span>
                    <div data-v-7c26ed95="" className="spacer"></div>
                    <span data-v-7c26ed95="" className="margin-5px-right text" style={{fontSize:"13px", color: "rgb(246, 195, 58)" }}>
                      { history.odds.length > 1 ? "멀티배팅" : "싱글배팅" }
                    </span>
                    <span data-v-7c26ed95="" className="text" style={{fontSize:"13px", opacity: "0.6" }}>{dateFormation(history.created_date, 9)}</span>
                  </div>

                      {
                        history.odds.map((list, index) => {
                          const historyList = convertBettingHistory(list, " ");
                          return (
                            <div key={index}>
                              <div data-v-7c26ed95="" className="log-wrap column" style={{ marginBottom: "15px" }}>
                                <div data-v-7c26ed95="" className="log column">
                                  <div data-v-7c26ed95="" className="d-flex" style={{ flexDirection: "row", ...height }}>
                                    <div data-v-7c26ed95="" className="margin-right-10- d-flex log_div " style={{ flexDirection: "row" }}>
                                      <span data-v-7c26ed95="" className="margin-5px-right text history_gameType" style={{ color: "rgb(232, 196, 20)", whiteSpace: "nowrap" }}>
                                        {historyList.gameType}
                                      </span>
                                      <div className="log_div  d-flex">
                                        <span data-v-7c26ed95="" className="margin-5px-right text">
                                          <img data-v-7c26ed95="" src={historyList.sportImg} className="sports-icon" style={{ width: "18px", height: "18px" }} alt="" />
                                        </span>
                                        <span data-v-7c26ed95="" className="text text-ellipsis sportType" style={{ width: "100px" }}>{historyList.sportName}</span>
                                      </div>
                                    </div>
                                    <div data-v-7c26ed95="" className="margin-right-10- d-flex log_div" style={{ flexDirection: "row" }}>
                                      <span data-v-7c26ed95="" className="margin-5px-right- text">
                                        <div data-v-3285b224="" data-v-7c26ed95="" className="tournament-icon d-flex"
                                          style={{ flexDirection: "row", width: "unset" }}>
                                          <img data-v-3285b224="" src={historyList.leagueImg} alt="" onError={onErrorImg} />
                                        </div>
                                      </span>
                                      <span data-v-7c26ed95="" className="text-ellipsis text" style={{ display: "block" }}>
                                        {historyList.leagueName}
                                      </span>
                                    </div>
                                    <div data-v-7c26ed95="" className="spacer"></div>
                                    <span data-v-7c26ed95="" className={`padding-horizontal-2 text ${historyList.winClass}`} style={{ flexShrink: "0" }}>
                                      {historyList.wintype}
                                    </span>
                                  </div>
                                  <div data-v-7c26ed95="" className="d-flex" style={{ flexDirection: "row", ...height }}>
                                    <div data-v-7c26ed95="" className="margin-5px-right d-flex log_div" style={{ flexDirection: "row" }}>
                                      <span data-v-7c26ed95="" className="text" style={{ opacity: "0.6" }}>{historyList.time}</span>
                                    </div>
                                    <div data-v-7c26ed95="" className="text-ellipsis d-flex log_div" style={{ flexDirection: "row" }}>
                                      <div data-v-7c26ed95="" className="text-ellipsis d-flex log_div" style={{ flexDirection: "row" }}>
                                        {/* <div data-v-cc68f3fe="" data-v-7c26ed95="" className="team-icon d-flex" style={{ flexDirection: "row", flexShrink: "0" }}>
                                                <img data-v-cc68f3fe="" src="../images/home.f33c6e6.png" className="blank-home" style={{ width: "16px", height: "16px" }} alt="" />
                                            </div> */}
                                        <span data-v-7c26ed95="" className="text-ellipsis-block text history_teamName red-color">
                                          {historyList.homeTeam}
                                        </span>
                                      </div>
                                      <span data-v-7c26ed95="" className="margin-10px-lr text " style={{ opacity: "0.6" }}>vs</span>
                                      <div data-v-7c26ed95="" className="text-ellipsis d-flex log_div" style={{ flexDirection: "row" }}>
                                        {/* <div data-v-cc68f3fe="" data-v-7c26ed95="" className="team-icon d-flex" style={{ flexDirection: "row", flexShrink: "0" }}>
                                                <img data-v-cc68f3fe="" src="../images/away.e0c4aae.png" className="" style={{ width: "16px", height: "16px" }} alt="" />
                                            </div> */}
                                        <span data-v-7c26ed95="" className="text-ellipsis-block text history_teamName blue-color">
                                          {historyList.awayTeam}
                                        </span>
                                      </div>
                                    </div>
                                  </div>


                                  {/* { (type !== "slot" && type !== "casino") && 
                                      <div data-v-7c26ed95="" className="pick d-flex" style={{ flexDirection: "row" }}>
                                          <span data-v-7c26ed95="" className="margin-5px-right text" style={{ color: "#f6c33a" }}>{history.marketName}</span>
                                          <span data-v-7c26ed95="" className="text">{history.marketDetail}</span>
                                          <div data-v-7c26ed95="" className="spacer">{history.baseline}</div>
                                          <span data-v-7c26ed95="" className="text" style={{ color: "#f6c33a" }}>{history.rate}</span>
                                      </div>
                                  } */}
                                  <div data-v-7c26ed95="" className="pick d-flex" style={{ flexDirection: "row", ...height }}>
                                    <div className="log_div d-flex w-100">
                                      <span data-v-7c26ed95="" className="margin-5px-right text" style={{ color: "#f6c33a" }}>{historyList.marketName}</span>
                                      <span data-v-7c26ed95="" className="text">{historyList.marketDetail}</span>
                                      <div data-v-7c26ed95="" className="spacer">
                                        {/* {historyList.baseline} */}
                                      </div>
                                      <span data-v-7c26ed95="" className="text" style={{ color: "#f6c33a" }}>{historyList.rate}</span>
                                    </div>
                                  </div>

                                  {/* ------------------- 베팅결과 ---------------------- */}
                                  {
                                    !isEmpty(list.bet_result) &&
                                    list.bet_result.map((result, index) => {
                                      const resultPrice = result.Price.find(price => price.version === -1);
                                      const winIndex = list.bet_result.findIndex(result => result.Status === 2);
                                      // console.log('result.Status: ', result.Status === 2, result.Status, result.Name);
                                      return ((result.Status === 2) || ((result.Status === 6) && (winIndex < 0))) && (
                                        <div data-v-7c26ed95="" className="pick d-flex" style={{ flexDirection: "row", ...height }} key={index}>
                                          <div className="log_div d-flex w-100">
                                            <span data-v-7c26ed95="" className="margin-5px-right text" style={{ color: "#f6c33a" }}>경기결과</span>
                                            <span data-v-7c26ed95="" className="text">
                                              {getMarketDetail(list, result.Name) + " 승 " +
                                                fixedNumber(isEmpty(resultPrice) ?
                                                  (isEmpty(result.Price[0]) ? 0 : result.Price[0].Price)
                                                  : resultPrice.Price)
                                              }
                                            </span>
                                            <div data-v-7c26ed95="" className="spacer">
                                              {/* {history.baseline} */}
                                            </div>
                                            {/* <span style={{wordSpacing: "5px", color: "#fff" }} key={index}>
                                                <em>{getMarketDetail(history, result.Name) + " 승 " + fixedNumber(isEmpty(resultPrice) ? 0 : resultPrice.Price) } </em>
                                                </span> */}
                                          </div>
                                        </div>
                                      )
                                    })
                                  }
                                  {/* ------------------- 베팅결과 끝---------------------- */}
                                </div>
                              </div>
                            </div>
                          );
                        })
                      }

                      <div data-v-7c26ed95="" className="total d-flex" style={{ flexDirection: "row", ...height }}>
                        <span data-v-7c26ed95="" className="text">
                          배팅폴더
                          <span data-v-7c26ed95="" className="margin-5px-left text" style={{ color: "rgb(246, 195, 58)" }}>{history.odds.length}</span>
                        </span>
                        <span data-v-7c26ed95="" className="text">
                          배팅금액
                          <span data-v-7c26ed95="" className="margin-5px-left text" style={{ color: "rgb(246, 195, 58)" }}>{Number(history.balance.bet).toLocaleString()}</span>
                        </span>
                        <span data-v-7c26ed95="" className="text">
                          배당
                          <span data-v-7c26ed95="" className="margin-5px-left text" style={{ color: "rgb(246, 195, 58)" }}>
                            {fixedNumber(Number(history.rate))}
                          </span>
                        </span>
                        <span data-v-7c26ed95="" className="text">
                          당첨금
                          <span data-v-7c26ed95="" className="margin-5px-left text" style={{ color: "rgb(246, 195, 58)" }}>
                            {Number(history.balance.win).toLocaleString()}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
    </Fragment>
  )
}

const mapStateToProps = state => ({
});

export default connect(mapStateToProps, { CancelBetting })(Sportshistory);


// WEBPACK FOOTER //
// ./src/components/account/hisotries/Sportshistory.js